const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const request = async (path, token, options = {}) => {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 12000);
  try {
    const response = await fetch(`${API}${path}`, {
      credentials: "include",
      headers: {
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(options.healthGrant ? { "X-AION-Health-Grant": options.healthGrant } : {}),
      },
      ...options,
      signal: controller.signal,
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
      const error = new Error(body.detail || `Request failed: ${response.status}`);
      error.status = response.status;
      throw error;
    }
    return body;
  } catch (error) {
    if (error?.name === "AbortError") {
      const timeoutError = new Error("Health-Anfrage braucht gerade zu lange. Bitte versuche es erneut.");
      timeoutError.status = 408;
      throw timeoutError;
    }
    throw error;
  } finally {
    window.clearTimeout(timeout);
  }
};

export const getPersonalHealthStatus = async (token) => request("/intelligence/health/status", token);
export const unlockPersonalHealth = async (password, token) => request("/intelligence/health/unlock", token, {
  method: "POST",
  body: JSON.stringify({ password }),
});
export const lockPersonalHealth = async (healthGrant, token) => request("/intelligence/health/lock", token, {
  method: "POST",
  healthGrant,
});
export const getPersonalHealthDashboard = async (healthGrant, token) => request("/intelligence/health/dashboard", token, { healthGrant });
export const updatePersonalHealthPrivacy = async (contextHintsEnabled, healthGrant, token) => request("/intelligence/health/privacy", token, {
  method: "PUT",
  healthGrant,
  body: JSON.stringify({ context_hints_enabled: contextHintsEnabled }),
});
export const submitPersonalHealthSnapshot = async (snapshot, healthGrant, token) => request("/intelligence/health/snapshot", token, {
  method: "PUT",
  healthGrant,
  body: JSON.stringify(snapshot),
});
export const requestPersonalHealthContextOffer = async (signal, token) => request("/intelligence/health/context-offer", token, {
  method: "POST",
  body: JSON.stringify({ signal }),
});
